module.exports = "<p>\n  provider-new works!\n</p>\n"